// Copyright (c) Docugami, Inc. All rights reserved.

import { AppState } from "@auth0/auth0-react";
import { OrganizationState } from "networking/OrganizationApi";
import { useAppSelector } from "./redux";

interface IOrgStatus {
    currentOrgInitializing: boolean | undefined;
    needToCreateAnOrg: boolean | undefined;
    waitlisted: boolean | undefined;
    unknown: boolean;
}

export function useOrgStatus(): IOrgStatus {
    const currentOrganization = useAppSelector((state: AppState) => state.organizations.currentOrganization);
    const organizationsFetched = useAppSelector((state: AppState) => state.organizations.organizationList.fetchState.fetched);
    const creationState = useAppSelector((state: AppState) => state.organizations.creationState);
    const organizations = useAppSelector((state: AppState) => state.organizations);

    return {
        currentOrgInitializing: !organizationsFetched ? undefined : creationState.creating || currentOrganization?.initializing || currentOrganization?.state === OrganizationState.Creating,
        needToCreateAnOrg: !organizationsFetched ? undefined : organizations.organizationList.allIds.length === 0 && !creationState.created && !creationState.creating,
        waitlisted: !organizationsFetched ? undefined : organizations.organizationList.allIds.length === 0 && creationState.waiting,
        unknown: creationState.unknown
    }
}
